module.exports = __webpack_public_path__ + "static/image/service/pc/shopping_live.jpg?88a9361e";